import "/global.scss";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  query,
  where,
  orderBy,
  getDocs,
  DocumentReference,
  Query,
  CollectionReference,
  Timestamp,
  enableIndexedDbPersistence,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { z } from "zod";

// Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCllLcTPlPfZnKO2agbymYfR5-c2ZOm0L0",
  authDomain: "dienstplan-ea810.firebaseapp.com",
  databaseURL: "https://dienstplan-ea810.firebaseio.com",
  projectId: "dienstplan-ea810",
  storageBucket: "dienstplan-ea810.appspot.com",
  messagingSenderId: "423111874572",
  appId: "1:423111874572:web:ef9f67da0136ce7493f629",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

//Initialize Firestore
export const db = getFirestore(app);
enableIndexedDbPersistence(db).catch((err) => {
  if (err.code == "failed-precondition") {
    console.error("Multiple tabs open, persistence can only be enabled in one tab at a a time");
  } else if (err.code == "unimplemented") {
    console.error("The current browser does not support all of the features required");
  }
});

//Initialize Auth
export const auth = getAuth();

//Format Definitions
export const dateTimeFormat = new Intl.DateTimeFormat("de", {
  weekday: "short",
  day: "2-digit",
  month: "long",
});

export function monthFormat(d: Date) {
  return d.toISOString().substring(0, 7);
}

export const monthName = new Intl.DateTimeFormat("de", {
  month: "long",
});
export const monthYear = new Intl.DateTimeFormat("de", {
  month: "long",
  year: "numeric",
});

//Date Definitions

export const nowDate = new Date();

export function monthOfDate(d: Date) {
  const m = new Date(d.getFullYear(), d.getMonth(), 1, 0);
  m.setHours(m.getHours() - m.getUTCHours() + 24);
  return m;
}

export function monthOffset(i: number) {
  const m = new Date(nowDate.getFullYear(), nowDate.getMonth() + i, 1, 0);
  m.setHours(m.getHours() - m.getUTCHours() + 24);
  return m;
}

// type Definitions
export const monthValidator = z.object({
  month: z.instanceof(Timestamp),
  offenFahrer: z.number().min(0),
  offenSani: z.number().min(0),
  lock: z.boolean(),
  lockPraktikant: z.boolean(),
});
export type monthType = z.infer<typeof monthValidator>;
export const dienstValidator = z.object({
  Dienst: z.instanceof(Timestamp),
  Fahrer: z.string(),
  Sani: z.string(),
  Praktikant: z.string(),
  Zusatz: z.string(),
  Tagdienst: z.boolean(),
});
export type dienstType = z.infer<typeof dienstValidator>;
export const userValidator = z.object({
  Abstreicher: z.boolean().optional(),
  Admin: z.boolean(),
  Dienstnummer: z.number(),
  Fahrer: z.boolean(),
  Name: z.string(),
  Sani: z.boolean(),
  Testing: z.boolean().optional(),
  durchschnitt: z.number(),
  eingDienste: z.number(),
  eingDiensteVerlauf: z.record(z.string(), z.number()),
});
export type userType = z.infer<typeof userValidator>;

//DB ref definitions
export const usersRef = collection(db, "users") as CollectionReference<userType>;
export const dienstplanRef = collection(db, "dienstplan") as CollectionReference<monthType>;

export function monthQuery(month: Date) {
  month = new Date(month.getFullYear(), month.getMonth(), 1);
  return query(dienstplanRef, where("month", "==", monthOfDate(month))) as Query<monthType>;
}

export function monthRangeQuery(start: Date, end: Date) {
  return query(
    dienstplanRef,
    where("month", ">=", monthOfDate(start)),
    where("month", "<=", monthOfDate(end)),
    orderBy("month")
  );
}

export function monthOffsetQuery(i: number) {
  return query(dienstplanRef, where("month", "==", monthOffset(i)));
}

export function dienstQuery(monthKalendarRef: DocumentReference) {
  return query(
    collection(monthKalendarRef, "kalender"),
    orderBy("Tagdienst"),
    orderBy("Dienst")
  ) as Query<dienstType>;
}
export let userMap = new Map<string, string>();
export let userMap_Fahrer = new Map<string, string>();
export let userMap_Sani = new Map<string, string>();

export async function getUserMap() {
  userMap = new Map<string, string>();
  userMap_Fahrer = new Map<string, string>();
  userMap_Sani = new Map<string, string>();
  const qs = await getDocs(usersRef);

  for (const doc of qs.docs) {
    const result = userValidator.safeParse(doc.data());
    if (!result.success) continue;
    const user = result.data;
    userMap.set(doc.id, user.Name);
    if (doc.get("Fahrer")) {
      userMap_Fahrer.set(doc.id, user.Name);
    }
    if (doc.get("Sani")) {
      userMap_Sani.set(doc.id, user.Name);
    }
  }
}

export function firestorePath2URL(path: string) {
  return (
    "https://console.firebase.google.com/u/0/project/dienstplan-ea810/firestore/data/" +
    path.replaceAll("/", "~2F")
  );
}

//Create Logout button
try {
  const headerDiv = document.querySelector<HTMLElement>(".container.clr.page-header-inner");
  if (!headerDiv) throw headerDiv;
  if (window.location.pathname.includes("login")) throw "on Login page";

  const logout = createElement("button", {
    style: { display: "inline-block" },
    text: "Logout",
    classes: ["right"],
    parent: headerDiv,
  });
  logout.onclick = () => {
    auth.signOut();
  };
  headerDiv.insertBefore(logout, headerDiv.firstChild);
  (<HTMLElement>headerDiv.children[2]).style.marginRight = "80px";
  console.log("created Logout button");
} catch (error) {
  console.log("could not create Logout button");
}

//HTML forging functions
export function createTable(
  tableHeadings: (string | HTMLTableCellElement)[],
  parent?: HTMLElement
): HTMLTableSectionElement | HTMLTableElement {
  const table = document.createElement("table");
  if (parent) parent.append(table);

  if (tableHeadings.length > 0) {
    const tableHead = document.createElement("thead");
    table.append(tableHead);
    const tr = document.createElement("tr");
    tableHead.append(tr);

    for (const heading of tableHeadings) {
      if (typeof heading === "string") {
        const th = document.createElement("th");
        th.innerText = heading;
        tr.append(th);
      } else tr.append(heading);
    }
  }

  const tableBody = document.createElement("tbody");
  table.append(tableBody);
  if (!parent) return table;
  else return tableBody;
}

export function createLoadingSpinner(parent?: HTMLElement) {
  const e = document.createElement("div");
  e.classList.add("loadingSpinner");
  parent?.appendChild(e);
  return e;
}

export function createElement<K extends keyof HTMLElementTagNameMap>(
  elementName: K,
  options?: {
    id?: string;
    name?: string;
    text?: string;
    href?: string;
    hidden?: boolean;
    value?: string;
    type?: string;
    for?: string;
    src?: string;
    span?: number;

    style?: { [prop: string]: string };
    classes?: string[];
    parent?: HTMLElement;
  }
) {
  const e = document.createElement<K>(elementName);
  if (!options) return e;
  const o = options;

  if (o.id) e.id = o.id;
  if (o.name) (<HTMLInputElement>e).name = o.name;
  if (o.text) e.innerText = o.text;
  if (o.href) (<HTMLAnchorElement>e).href = o.href;
  if (o.hidden) e.hidden = o.hidden;
  if (o.value) (<HTMLInputElement>e).value = o.value;
  if (o.type) (<HTMLButtonElement>e).type = o.type;
  if (o.for) (<HTMLLabelElement>e).htmlFor = o.for;
  if (o.src) (<HTMLImageElement>e).src = o.src;
  if (o.span) (<HTMLTableColElement>e).span = o.span;

  for (const s in o.style) e.style.setProperty(s, o.style[s]);
  if (o.classes) e.classList.add(...o.classes);

  if (o.parent) o.parent.append(e);

  return e;
}

//define static file paths
export const clearIcon = "/app/assets/icons/clear-24px.svg";
